import moment from 'moment';

export const subjectId = (state) => state.subjectId || '';

export const gender = (state) => state.gender || '';

export const birthYear = (state) => state.birthYear || '';

export const startDate = (state) => state.startDate ? moment(state.startDate).format('DD-MM-YYYY') : '';

export const medicationList = (state) => state.medicationList || [];
